export default __webpack_public_path__ + "static/media/relax.2762cdf6.png";